/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Instancias.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/instancias',
    name: 'instancias.index',
    component: () => import('./views/InstanciasIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'instancias.read',
      title: 'Instancias',
    },
  },
]

export default routes
